
export default {
  namespaced: true,
  state: {
    errors: []
  },
  actions: {
    async addError ({ state, commit, getters }, error) {
      commit('addError', error)
    },
    async clearErrors ({ state, commit, getters }) {
      commit('clearErrors')
    },
    async clearError ({ state, commit, getters }, data) {
      commit('clearError', data)
    }
  },
  getters: {
    getError: state => (input, sku) => {
      if (sku === undefined) {
        sku = input
      }
      const result = state.errors.find(error => (error.sku === sku || error.productId === sku || sku === input) && error.property === input)

      if (result !== undefined) {
        return result.error
      }

      return
    },
    getErrors: state => (sku) => {
      if (!state.errors.length) {
        return false
      }

      const result = state.errors.find(error => error.sku === sku && error.productId === sku)

      if (result !== undefined) {
        return result
      }

      return false
    },
    getErrorBySku: state => (input, sku) => {
      if (!state.errors.length) {
        return
      }

      const result = state.errors.find(error => error.sku === sku && error.property === input)

      if (result !== undefined) {
        return result.error
      }

      return
    },
    getErrorsBySku: state => (sku) => {
      if (!state.errors.length) {
        return false
      }

      const result = state.errors.find(error => error.sku === sku)

      if (result !== undefined) {
        return result
      }

      return false
    },
    getErrorByProductId: state => (input, productId) => {
      if (!state.errors.length) {
        return
      }

      const result = state.errors.find(error => error.productId === productId && error.property === input)

      if (result !== undefined) {
        return result.error
      }

      return
    },
    getErrorsByProductId: state => (productId) => {
      if (!state.errors.length) {
        return false
      }

      const result = state.errors.find(error => error.productId === productId)

      if (result !== undefined) {
        return result
      }

      return false
    }
  },
  mutations: {
    addError (state, error) {
      state.errors.push(error)
    },
    clearErrors (state) {
      state.errors = []
    },
    clearError (state, data) {
      var position = null

      state.errors.forEach(function (err, i) {
        if (err.productId === data.sizeRow) {
          if (err.property === data.attribute) {
            position = i
          }
        }
      })
      state.errors.splice(position, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/panel/errors.js